// src/components/RouteTracker.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = ({ children, onPathChange }) => {
  const location = useLocation();
  const prevLocationRef = useRef(null);

  useEffect(() => {
    if (prevLocationRef.current !== location.pathname) {
      const previousPath = prevLocationRef.current;
      prevLocationRef.current = location.pathname;
      if (onPathChange) {
        onPathChange(previousPath);
      }
    }
  }, [location, onPathChange]);

  return children;
};

export default RouteTracker;
